import styled from 'styled-components';

// Подпись поля отдельной строкой с отступом — иначе label и контрол слипаются
const FieldLabel = styled.div`
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
  line-height: 1.4;
`;

// Заголовок режима панели
export const PanelTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
`;

export default FieldLabel;
